import { createFileRoute } from '@tanstack/react-router';

import { useTranslation } from '@apple/lib/i18next';
import { TitleLayout } from '@apple/ui/layouts/TitleLayout';

import { AddressBook } from '@apple/features/address-book/components/AddressBook';
import { requireAuth } from '@apple/features/auth/utils/require-auth';

export const Route = createFileRoute('/_authed/address-book')({
	beforeLoad: args => requireAuth(args),
	component: AddressBookRoute,
});

function AddressBookRoute() {
	const { t } = useTranslation('address-book');

	return (
		<TitleLayout title={t('title')}>
			<AddressBook />
		</TitleLayout>
	);
}
